import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Job team members holding any of the given roles, for the workflow step editor. */
export function useJobTeamByRoles(
  jobId: number | null | undefined,
  roleIds: readonly number[],
) {
  return useQuery({
    queryKey: queryKeys.jobs.teamByRoles(jobId ?? -1, roleIds),
    queryFn: ({ signal }) =>
      jobApiClient.getTeamByRoles(
        jobId!,
        { roles: [...roleIds] },
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'job team by roles' },
  });
}
